import styled, { css } from "styled-components"

import { media } from "../../styles"

export const DisabledMessage = styled.div`
  color: ${({ theme }) => theme.spaceblue};
  display: block;
  font-size: 14px;
  line-height: 1.2;
  opacity: 0.5;
  padding: 5px 0 0;
  position: absolute;
  text-align: left;
  top: 100%;
  transition: opacity ${({ theme }) => theme.transitionTime};
  /* width: 100%; */
`

export const InputContainer = styled.div`
  position: relative;
  margin: 0 0 20px;
  min-height: 60px;
  font-size: 16px;
  line-height: 23px;
  padding: 24px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}

  @media ${media.xl} {
    font-size: 20px;
    line-height: 31px;
  }

  &:hover {
    ${DisabledMessage} {
      opacity: 1;
    }
  }
`

export const InputWrapper = styled.span`
  position: relative;
  flex: 1;
`

export const InputGroup = styled.span`
  display: flex;
  position: relative;
`

export const InputFieldLabel = styled.label`
  color: ${({ theme }) => theme.spaceblue};
  top: 29px;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  transform: translate3d(0, 0, 0);
  transform-origin: 0;
  transition:
    transform ${({ theme }) => theme.transitionTime},
    font-weight ${({ theme }) => theme.transitionTime};
  user-select: none;

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}

  ${(props) =>
    props.$active &&
    css`
      font-weight: 700;
      pointer-events: all;
      transform: scale(0.875) translate3d(0, -30px, 0);
    `}
`

export const InputFieldIcon = styled.div`
  position: absolute;
  right: 0;
  bottom: 10px;
  width: 16px;
  height: 16px;
  pointer-events: none;

  @media ${media.xl} {
    bottom: 20px;
  }

  ${(props) =>
    props.$highlight &&
    css`
      color: ${props.theme.sun};
    `}

  ${(props) =>
    props.$error &&
    css`
      color: ${props.theme.error};
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
    `}

  svg {
    height: auto;
    width: 100%;
  }
`

export const InputFieldIconLeft = styled.div`
  position: absolute;
  left: 0;
  bottom: 8px;
  width: 18px;
  height: 18px;
  pointer-events: none;

  @media ${media.xl} {
    bottom: 16px;
  }

  svg {
    height: auto;
    width: 100%;
  }
`

export const InputExtra = styled.span`
  padding: 5px 0 5px 10px;
`

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.error};
  display: block;
  font-size: 14px;
  line-height: 1.2;
  padding: 5px 0 0;
  position: absolute;
  text-align: left;
  top: 100%;
  width: 100%;
`

export const HelpText = styled.div`
  color: ${({ theme }) => `rgba(${theme.spaceblueRGB}, 0.5)`};
  display: block;
  font-size: 14px;
  line-height: 1.2;
  text-align: left;
  margin-bottom: 15px;
  margin-top: 5px;
  top: 100%;

  ${(props) =>
    props.$hideOnTouch &&
    css`
      @media (pointer: coarse) {
        display: none;
      }
    `}

  ${(props) =>
    props.$error &&
    css`
      opacity: 1;

      &,
      strong {
        color: ${props.theme.error};
      }
    `}

  ${(props) =>
    props.$fixedPosition &&
    props.$fixedPosition === "right" &&
    css`
      position: absolute;
      right: 0;
    `}

  kbd {
    border: 1px solid ${({ theme }) => `rgba(${theme.spaceblueRGB}, 0.5)`};
    border-radius: 3px;
    margin: 0 3px;
    font-size: 12px;
    padding: 2px 3px;
  }

  strong {
    color: ${({ theme }) => `rgba(${theme.spaceblueRGB}, 0.65)`};
  }
`
